import { HttpErrorResponse } from '@angular/common/http';

export function isSingleErrorCode(
  err: HttpErrorResponse,
  code: string,
): boolean {
  return (
    err.status === 400 &&
    err.error.errors instanceof Array &&
    err.error.errors.length === 1 &&
    err.error.errors[0] === code
  );
}
